import { axiosClient } from '@nx-frontend/shared/api';
import { TaskListDTO } from '@nx-frontend/shared/types';

interface UpdateTaskListParams {
  gatewayUrl: string;
  workspaceId: string;
  taskListId: string;
  sessionId: string;
  data: {
    noteGlobalId?: string;
    title?: string;
    order?: string[];
  };
}

export async function updateTaskListById({
  workspaceId,
  taskListId,
  sessionId,
  gatewayUrl,
  data,
}: UpdateTaskListParams): Promise<TaskListDTO | null> {
  try {
    const response = await axiosClient.post<TaskListDTO>(
      `${gatewayUrl}/svc:note-task/workspaces/${workspaceId}/taskLists/${taskListId}`,
      {
        ...data,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'everhelper-session-id': sessionId,
        },
      }
    );
    return response.data;
  } catch (err) {
    console.error('Fail to update taskList by ', taskListId, ' id');
  }
  return null;
}
